/**
 * Rejection reason constants and types for mention review
 *
 * These values must match the backend validation exactly.
 * Used across all mention rejection flows (individual and bulk).
 */

export const REJECTION_REASONS = {
  WRONG_BUSINESS: 'WrongBusiness',
  NOT_A_REAL_MENTION: 'NotARealMention',
  SPAM: 'Spam',
  DUPLICATE: 'Duplicate',
  LOCATION_WORD_MATCH: 'LocationWordMatch',
  GENERIC_MATCH: 'GenericMatch',
  OTHER: 'Other'
} as const;

export type RejectionReason = typeof REJECTION_REASONS[keyof typeof REJECTION_REASONS];

/**
 * Options for rejection reason dropdown/select components
 * Maintains consistent labels across all rejection UIs
 */
export const REJECTION_REASON_OPTIONS = [
  { value: REJECTION_REASONS.WRONG_BUSINESS, label: 'Wrong Business Matched' },
  { value: REJECTION_REASONS.NOT_A_REAL_MENTION, label: 'Not a Real Business Mention' },
  { value: REJECTION_REASONS.SPAM, label: 'Spam or Low Quality' },
  { value: REJECTION_REASONS.DUPLICATE, label: 'Duplicate Mention' },
  { value: REJECTION_REASONS.LOCATION_WORD_MATCH, label: 'Location Word Match (Street/City Name)' },
  { value: REJECTION_REASONS.GENERIC_MATCH, label: 'Generic Word Match' },
  { value: REJECTION_REASONS.OTHER, label: 'Other Reason' }
] as const;
